import { useMemo } from 'react';
import { useHostBridge } from '../context/HostBridgeContext';

/**
 * Permission gate for the chat. A standalone iframe has no platform SideNav /
 * SSO, so permissions are delivered by the host in the init handshake. When the
 * host supplies no list we fall back to "allowed" (the host is responsible for
 * only embedding the iframe for entitled users + the API enforces auth anyway).
 */
const PERMISSION_USE = 'chatbot:Use';

export function useChatPermissions() {
  const { session } = useHostBridge();

  return useMemo(() => {
    const permissions = session?.permissions ?? [];
    const hasExplicit = permissions.length > 0;
    const canUse = !hasExplicit || permissions.includes(PERMISSION_USE);
    return { canUse, permissions };
  }, [session]);
}
